import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../../Common/AdminBreadcrumb';
import { GetCorporate, DeleteCorporate } from '../../../../API/admin'
import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Swal from 'sweetalert2';
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from '@coreui/react'

const Corporates = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Teams', to: '/teams', active: true }
    ];
    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;

    const [Corporates, setCorporates] = useState([]);
    const Navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    let GetCorporateAPI = async () => {
        let res = await GetCorporate()
        if (res.status) {
            setCorporates(res.data);
        } else {
            setCorporates([]);
        }
    }

    const HandelDelete = async (urlid) => {
        let res = await Swal.fire({
            title: "Are you sure?",
            text: "Are you sure , you want to delete this Team?",
            //   icon: "warning"
        });
        if (res.isConfirmed) {
            let callAPI = async () => {
                let corporateID = {
                    id: urlid
                }
                let res = await DeleteCorporate(corporateID);
                if (res.status) {
                    enqueueSnackbar("Team Deleted successfully", {
                        variant: 'success', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    });
                    GetCorporateAPI()
                } else {
                    //   enqueueSnackbar("Can not delete corporate", { variant: 'error' , action: (key) => (
                    //     <button className='toast_close_btn'
                    //         onClick={() => {
                    //             // Close the Snackbar
                    //             closeSnackbar(key);
                    //         }}
                    //     >
                    //         X
                    //     </button>
                    // ),});
                    Navigate('/corporate')
                }
            }
            callAPI();
        }
    }

    const HandelChange = (event) => {
        let callAPI = async () => {
            let res = await GetCorporate(search)
            if (res.status) {
                setCorporates(res.data);
            } else {
                enqueueSnackbar("No Record Found ", {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                });
                Navigate('/corporate');
            }
        }
        let search = {
            data: event.target.value
        }
        callAPI(search);
    }

    useEffect(() => {
        GetCorporateAPI()
    }, [])
    function toTitleCase(str) {
        return str
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase());
    }
    return (
        <>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />

            <CCard>
                <CCardBody>
                    <CRow>
                        <CCol lg={4}>
                            <h3 className="card-title mb-3">
                                Teams
                            </h3>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg={3} className=" d-md-block mb-2">
                            <input type="search" className='form-control' placeholder="Search" name='data' onChange={HandelChange} />
                        </CCol>
                        <CCol lg={9}>
                            <Link to={'/teams/create'}>
                                <CButton className='float-end text-white' color="info">
                                    <i className="bi bi-plus-circle me-2"></i>
                                    Add Team
                                </CButton>
                            </Link>
                        </CCol>
                    </CRow><br />
                    {/* <MainChart /> */}
                    <CRow
                        xs={{ cols: 1, gutter: 4 }}
                        sm={{ cols: 2 }}
                        lg={{ cols: 4 }}
                        xl={{ cols: 5 }}
                        className="mb-2 text-center custom_scroll_table_scroll"
                    >
                        <CTable striped>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">S.NO</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Logo</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">City</CTableHeaderCell>

                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {
                                    Corporates.length > 0 ? (<>
                                        {Corporates.map((corporate, index) => (
                                            <CTableRow>
                                                <CTableDataCell key={index}>{index + 1}</CTableDataCell>
                                                <CTableDataCell key={index}>
                                                    <img
                                                        src={IMAGE_URL + 'teams/' + corporate.logo}
                                                        className='group-table-img mb-2'
                                                        alt='blank_user'
                                                    />
                                                </CTableDataCell>
                                                <CTableDataCell key={index}>{toTitleCase(corporate.domain)}</CTableDataCell>
                                                <CTableDataCell key={index}>{corporate.city != undefined ? corporate.city : 'N/A'}</CTableDataCell>

                                                <CTableDataCell key={index} >
                                                    {/* <Link to={`/corporate/detail?id=${corporate._id}`}>
                                                <CButton title='View'  className='bi bi-eye-fill text-white me-2' color="primary"></CButton>
                                            </Link> */}
                                                    <div className='d-flex justify-content-center'>
                                                        <Link to={`/teams/edit?id=${corporate._id}`}>
                                                            <CButton title='Edit' className='bi bi-pencil text-white admin_btn_space' color="warning"></CButton>
                                                        </Link>
                                                        <CButton title='Delete' className='bi bi-trash-fill text-white mx-2 admin_btn_space' color="danger" onClick={() => HandelDelete(corporate._id)}></CButton>
                                                    </div>
                                                </CTableDataCell>
                                            </CTableRow>
                                        )
                                        )}

                                    </>) : <CTableDataCell colSpan={5}>No Data Found</CTableDataCell>

                                }
                            </CTableBody>
                        </CTable>
                    </CRow>
                </CCardBody>
            </CCard>
        </>
    )
}

export default Corporates;